import React from 'react';
import Contact from './Contact';

const Search = () => {
  return (
    <section className="search">
      <div className="logo">COVID-19</div>
      <Contact />
    </section>
  );
};

export default Search;
